import { select } from "redux-saga/effects";
import { RootState } from "../redux/rootReducers";

export const BASE_URL = 'https://meraki.santobarnabas.org/naxxramas/api';
export const FILES_URL = 'https://meraki.santobarnabas.org/naxxramas/files';
// export const BASE_URL = 'http://localhost/meraki-backend/public/api';
// export const FILES_URL = 'http://localhost/meraki-backend/public/files';
export const UPLOAD_ROOMS_URL = `${FILES_URL}/uploads/rooms/`;
export const API_URL_AUTH = {
  BY_TOKEN: `${BASE_URL}/user/verify`,
  BY_CREDENTIALS: `${BASE_URL}/user/login`
}
export const API_URL_USER = {
  GET_USERS: (page: number) => `${BASE_URL}/user`,
  CREATE_USER: `${BASE_URL}/user`,
  UPDATE_USER: (id: number) => `${BASE_URL}/user/${id}`,
  SELECT_USER: (id: number) => `${BASE_URL}/user/detail?id=${id}`,
};
export const API_URL_ROLE = {
  GET_ROLES: (page: number) => `${BASE_URL}/role`,
  CREATE_ROLE: `${BASE_URL}/role`,
  UPDATE_ROLE: (id: number) => `${BASE_URL}/role/${id}`,
  SELECT_ROLE: (id: number) => `${BASE_URL}/role/detail?id=${id}`,
};
export const API_URL_BOOKING = {
  GET_BOOKINGS: (page: number) => `${BASE_URL}/booking?page=${page}`,
  CREATE_BOOKING: `${BASE_URL}/booking`,
  UPDATE_BOOKING: (id: number) => `${BASE_URL}/booking/${id}`,
  SELECT_BOOKING: (id: number) => `${BASE_URL}/booking/detail?id=${id}`,
  SEARCH_BOOKING: (startTime: string, endTime: string) => `${BASE_URL}/booking/search?start_time=${startTime}&end_time=${endTime}`,
};
export const API_URL_INVENTORY = {
  GET_INVENTORIES: (page: number) => `${BASE_URL}/inventory?page=${page}`,
  CREATE_INVENTORY: `${BASE_URL}/inventory`,
  UPDATE_INVENTORY: (id: number) => `${BASE_URL}/inventory/${id}`,
  SELECT_INVENTORY: (id: number) => `${BASE_URL}/inventory/detail?id=${id}`,
};
export const API_URL_ROOM = {
  GET_ROOMS: (page: number) => `${BASE_URL}/room?page=${page}`,
  CREATE_ROOM: `${BASE_URL}/room`,
  UPDATE_ROOM: (id: number) => `${BASE_URL}/room/${id}`,
  SELECT_ROOM: (id: number) => `${BASE_URL}/room/detail?id=${id}`,
};


/**
 * Execute API call with method get
 * @param url 
 * @param token 
 * @returns 
 */
export const apiGet = (url: string, token: string) => {
  const payload: any = {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
      'Accept': 'application/json; charset=utf-8'
    },
  };
  return fetch(url, payload);
};

/**
 * Execute API call with method post
 * @param url 
 * @param token 
 * @param data 
 * @returns promise
 */
export const apiPost = (url: string, token: string, data: any) => {
  let payload: any = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': "application/json; charset=UTF-8;",
      'Accept': 'application/json; charset=utf-8'
    }
  }

  if (token) {
    payload = {
      ...payload,
      headers: {
        ...payload.headers,
        'Authorization': `Bearer ${token}`,
      }
    }
  }
  console.log(payload);
  return fetch(url, payload);
};

/**
 * Execute API for file upload
 * @param url 
 * @param token 
 * @param data 
 * @returns promise
 */
export const apiUpload = (url: string, token: string, data: any) => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': `Basic ${btoa(`${token}:`)}`,
      'Accept': 'application/json; charset=utf-8'
    },
    body: data,
  });
};

/**
 * Execute API call with method put
 * @param url 
 * @param token 
 * @param data 
 * @returns promise
 */
export const apiPut = (url: string, token: string, data: any) => {
  return fetch(url, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': "application/json; charset=UTF-8",
      'Accept': 'application/json; charset=utf-8'
    },
    body: JSON.stringify(data),
  });
};

/**
 * Convert object into url parameters.
 * @param object 
 * @returns ?param1=value&param2=value
 */
export const objectToParams = (object: any): string => {
  let str = "";
  for (var key in object) {
    if (str !== "") {
      str += "&";
    }
    str += key + "=" + encodeURIComponent(object[key]);
  }
  return "?" + str;
}

/**
 * Retrieve current user token.
 * @returns token
 */
export function* retrieveToken() {
  const tokenState = (state: RootState) => state.authorization.token;
  const tokenAuth: string = yield select(tokenState);
  const token: string = `${tokenAuth}`;
  return token;
}